var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4874 10.9047C17.4093 12.3515 16.9138 13.7447 16.0608 14.9159C15.2078 16.087 14.0338 16.9861 12.6807 17.5043C11.3277 18.0225 9.85349 18.1377 8.43637 17.836C7.01924 17.5342 5.71985 16.8285 4.69527 15.804C3.67069 14.7795 2.96479 13.4802 2.6629 12.0631C2.36101 10.646 2.47605 9.1718 2.99412 7.81869C3.51219 6.46559 4.4111 5.29151 5.5822 4.43838C6.7533 3.58525 8.14644 3.0896 9.59322 3.01135C9.93072 2.99301 10.1074 3.39468 9.92822 3.68051C9.32896 4.63931 9.07237 5.77291 9.2003 6.89631C9.32824 8.01971 9.83316 9.06658 10.6327 9.86608C11.4322 10.6656 12.479 11.1705 13.6024 11.2984C14.7258 11.4264 15.8594 11.1698 16.8182 10.5705C17.1049 10.3913 17.5057 10.5672 17.4874 10.9047Z",
    stroke: "#282D38",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/dark.49568010915c7bd8a77fe7805ed6618f.svg";
export { ForwardRef as ReactComponent };